<script setup>
/**
 * 假日休息通知 Modal (WeekendModal.vue)
 *
 * 週末顯示「助教休息中」的提示 Modal，並以 lottie 播放動畫。
 *
 * @fires close - 關閉 Modal
 */
import { onMounted } from 'vue';
import lottie from 'lottie-web';

onMounted(() => {
  lottie.loadAnimation({
    container: document.getElementById('svgContainer'),
    animType: 'svg',
    loop: true,
    autoplay: true,
    path: 'https://raw.githubusercontent.com/Tzuhui/test-view/main/Reply-Modal.json',
  });
});

</script>

<template>
  <div class="weekend-modal-bg">
    <div class="weekend-modal">
      <div class="d-flex flex-column align-items-center justify-content-center text-center">
        <div id="svgContainer" />
        今天是假日，助教正在休息中<br>平日會再批改您的作業與問題哦～
      </div>
      <div class="d-flex align-items-center justify-content-center my-3">
        <button
          class="btn btn-hex-primary px-4 rounded-0"
          @click="$emit('close')"
        >
          OK，沒問題
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.weekend-modal-bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  min-height: 550px;
  background-color: rgba(0, 0, 0, 0.4);
}
.weekend-modal {
  background-color: white;
  position: absolute;
  top: 50px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10000;
  width: 65%;
  padding-top: 32px;
  padding-bottom: 32px;
  border-radius: 1rem;
}
</style>

<spec lang="md">
# 假日休息通知 Modal (WeekendModal.vue)

## 元件概述
- **用途**：週末時顯示助教休息中的提示 Modal，搭配 lottie 動畫。

## Props
無

## Emits
| 事件名稱 | 參數 | 說明 |
|---------|-----|------|
| close | `()` | 點擊「OK，沒問題」時觸發 |

## Slots
無

## 功能行為
- `onMounted` 時以 `lottie.loadAnimation` 於 `#svgContainer` 載入並自動播放循環動畫
- 顯示「今天是假日，助教正在休息中」提示文字
- 點擊「OK，沒問題」時 emit `close`

## 測試行為
- 應顯示提示文字「今天是假日，助教正在休息中」
- `onMounted` 時應呼叫 `lottie.loadAnimation`，並以 `#svgContainer` 為容器
- 點擊「OK，沒問題」時，應 emit `close`

## UI 規格
- 半透明黑色遮罩 `.weekend-modal-bg`（全螢幕、z-index 10000）
- 白色 Modal `.weekend-modal`，圓角 1rem、置中偏上（top 50px）
- 動畫容器 `#svgContainer` 置中
- 底部置中「OK，沒問題」按鈕（btn-hex-primary）
</spec>
